import './WhatThisLooksLikeSection.scss'

const WhatThisLooksLikeSection = () => (
  <section className="lnn-section lnn-looksSection">
    <div className="lnn-shell" data-reveal="up">
      <div className="lnn-looksSection__head">
        <h2>What This Looks Like</h2>
      </div>

      <div className="lnn-looksSection__grid">
        <div className="lnn-looksSection__statement">
          <p>A leadership team believes a decision is clear.</p>
          <p>Shortly after:</p>
        </div>

        <ol className="lnn-looksSection__steps">
          <li>teams move in different directions</li>
          <li>execution slows</li>
          <li>leaders re-engage</li>
          <li>decisions reopen</li>
        </ol>

        <div className="lnn-looksSection__result">
          <p>Not because the decision was wrong.</p>
          <p>Because it was not interpreted the same way.</p>
        </div>
      </div>
    </div>
  </section>
)

export default WhatThisLooksLikeSection
